import { Observable } from 'rxjs';
import { filter, map } from 'rxjs/operators';
import { BaseAsyncValue } from '../../../shared/models/async-value';
import { getOneClickSelectedOrder } from '../../selectors/one-click-orders.selector';

export class OneClickProductProvider extends BaseAsyncValue<string> {
  getValue(): Observable<string> {
    return this.store.select(getOneClickSelectedOrder).pipe(
      filter(order => !!order && !!order.items && !!order.items.length),
      map(order => order.items[0]),
      map(item => {
        return `${item.product.productCode.replace(/^0+/, '')} / ${item.product.productDesc || ''}`;
      }),
    );
  }
}
